// Strip HTML tags and WordPress comments
export function stripHtml(html) {
    if (typeof html !== 'string') return html;
    // Remove WordPress comments
    let text = html.replace(/<!--[\s\S]*?-->/g, '');
    // Remove HTML tags
    text = text.replace(/<[^>]*>/g, '');
    // Decode common HTML entities
    const entities = {
        '&nbsp;': ' ',
        '&amp;': '&',
        '&quot;': '"',
        '&lt;': '<',
        '&gt;': '>',
        '&#8211;': '–',
        '&#8212;': '—',
        '&#8217;': "'",
        '&#8216;': "'",
        '&#8220;': '“',
        '&#8221;': '”',
        '&apos;': "'"
    };
    text = text.replace(/&[#\w]+;/g, (m) => entities[m] || m);
    
    // Collapse 3 or more newlines (with optional whitespace) into exactly 2 newlines
    text = text.replace(/\n\s*\n\s*\n+/g, '\n\n');
    // Also collapse multiple spaces on a single line
    text = text.replace(/[ \t]{2,}/g, ' ');
    
    return text.trim();
}
